import {
  CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS,
  UCCO_FILL_MATERIALS_FORM,
  CCOF_RESET_FORM,
  UCCO_INIT,
  UCCO_SET_BACKEND_ERRORS,
  CASE_CREATION_ORDERS_RECEIVE_ORDER
} from "../mutations/available";
import _ from 'lodash'
import router from "../../router";
import {WrongParametersCode} from "../../dictionaries/api-error-codes";
import { getStringOrNull } from '../../helpers/strings'
import api from '@/api'

const isValidPatientBirthday = (value) => {
  if (!value || typeof value !== 'string') {
    return false
  }

  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) {
    return false
  }

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const parsedDate = new Date(Date.UTC(year, month - 1, day))

  if (
    parsedDate.getUTCFullYear() !== year ||
    parsedDate.getUTCMonth() !== month - 1 ||
    parsedDate.getUTCDate() !== day
  ) {
    return false
  }

  const todayIsoDate = new Date().toISOString().substr(0, 10)
  return value >= '1900-01-01' && value <= todayIsoDate
}

export const fillUpdatedCaseOrder = async ({commit, state, dispatch}, orderId) => {
  let index = _.findIndex(state.caseCreationOrders.items, function (item) {
    return item.id === orderId
  })

  if (index < 0) {
    await dispatch('caseCreationOrdersLoadOne', orderId)
  }

  index = _.findIndex(state.caseCreationOrders.items, function (item) {
    return item.id === orderId
  })

  if (index < 0) {
    console.log('error case creation request loading')
    return
  }

  commit(UCCO_INIT, state.caseCreationOrders.items[index])
}

export const uccoFillMaterialsForm = async ({commit}, materialsForm) => {
  commit(UCCO_FILL_MATERIALS_FORM, materialsForm)
}

export const caseCreationOrdersUpdate = async ({commit, state, dispatch}, {vue, immediateValidation = false, immediateCreation = false}) => {
  let resultMaterials = {}
  for (let type in state.updateCaseCreationOrder.form.data.materials) {
    if (!state.updateCaseCreationOrder.form.data.materials.hasOwnProperty(type)) {
      continue
    }

    if (!state.updateCaseCreationOrder.form.data.materials[type]) {
      continue
    }

    if (state.updateCaseCreationOrder.form.data.materials[type].length === 0) {
      continue
    }

    resultMaterials[type] = []

    for (let material of state.updateCaseCreationOrder.form.data.materials[type]) {
      const materialPayload = {
        code: material.code,
        description: material.description
      }
      if (type === 'tissues' && material.fragments != null) {
        materialPayload.fragments = Number(material.fragments)
      }
      resultMaterials[type].push(materialPayload)
    }
  }

  let files = []

  for (let file of state.updateCaseCreationOrder.form.data.files) {
    //Если файл, уже был ранее загружен
    if (!file.file) {
      files.push({
        id: file.id,
        name: file.name
      })
      continue
    }

    if (!file.success) {
      continue
    }

    files.push({
      id: file.fileId,
      name: file.name
    })
  }

  const orderId = state.updateCaseCreationOrder.data.id

  commit(UCCO_SET_BACKEND_ERRORS, {})

  const patientBirthday = state.updateCaseCreationOrder.form.data.patientBirthday
  if (!isValidPatientBirthday(patientBirthday)) {
    vue.$snotify.error(vue.$t('caseCreationOrderForm.fields.patientBirthday.errors.invalid'))
    return
  }

  commit(CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS, {orderId: orderId, action: 'update', value: true})

  try {
    await api.updateCaseCreationOrder({
      id: orderId,
      patientName: getStringOrNull(state.updateCaseCreationOrder.form.data.patientName),
      patientGender: state.updateCaseCreationOrder.form.data.patientGender,
      patientBirthday: state.updateCaseCreationOrder.form.data.patientBirthday,
      patientAddress: getStringOrNull(state.updateCaseCreationOrder.form.data.patientAddress),
      patientPhone: getStringOrNull(state.updateCaseCreationOrder.form.data.patientPhone),
      patientEmail: getStringOrNull(state.updateCaseCreationOrder.form.data.patientEmail),
      omi_policy_number: getStringOrNull(state.updateCaseCreationOrder.form.data.omi_policy_number),
      diagnosis: getStringOrNull(state.updateCaseCreationOrder.form.data.diagnosis),
      clientSpecialist: getStringOrNull(state.updateCaseCreationOrder.form.data.clientSpecialist),
      clinicalData: getStringOrNull(state.updateCaseCreationOrder.form.data.clinicalData),
      examination: getStringOrNull(state.updateCaseCreationOrder.form.data.examination),
      receiveMaterialMethod: (state.updateCaseCreationOrder.form.data.receiveMaterialMethod && state.updateCaseCreationOrder.form.data.receiveMaterialMethod.length)
        ? state.updateCaseCreationOrder.form.data.receiveMaterialMethod
        : null,
      services: state.updateCaseCreationOrder.form.data.services,
      externalId: getStringOrNull(state.updateCaseCreationOrder.form.data.externalId),
      externalLabel: getStringOrNull(state.updateCaseCreationOrder.form.data.externalLabel),
      files: files,
      materials: resultMaterials,
      immediateCreation: immediateCreation,
      immediateValidation: immediateValidation
    })
    commit(CCOF_RESET_FORM, 'updateCaseCreationOrder')
    vue.$snotify.success(vue.$t('caseCreationOrderForm.messages.successCreate'))
    vue.$refs['updateCaseCreationOrderForm'].reset()
    router.push({name: 'caseCreationOrders'})
  } catch (e) {

    const caseCreationOrder = _.get(e, ['data', 'caseCreationOrder'], null)

    if (caseCreationOrder !== null) {
      commit(UCCO_INIT, caseCreationOrder)
    }

    if (e.code && e.code === WrongParametersCode) {
      commit(UCCO_SET_BACKEND_ERRORS, e.body)
    } else {
      vue.$snotify.error(vue.$t('caseCreationOrderForm.messages.unableToCreate'))
      console.log(e)
    }
  }

  commit(CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS, {orderId: orderId, action: 'update', value: false})
}